import { render } from "./PaidBillsStreams.vue?vue&type=template&id=2fadac8f&scoped=true"
import script from "./PaidBillsStreams.vue?vue&type=script&lang=js"
export * from "./PaidBillsStreams.vue?vue&type=script&lang=js"

import "./PaidBillsStreams.vue?vue&type=style&index=0&id=2fadac8f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fadac8f"]])

export default __exports__